<template>
  <div id="narasumber-page">
    <page-header-component
      v-if="topics"
      @filterChange="filterChange"
      icon="bi bi-person-vcard"
      title="Narasumber (Beta)"
      :topics="topics"
      :hideValidate="false"
    />
    <div v-if="is_narasumber" class="row m-t-10">
      <div class="col-12">
        <div class="row">
          <div class="col-3 px-gap">
            <div class="bg-white p-3 entity-result shade">
              <h5>
                Daftar Narasumber
                <button
                  id="tambah-narasumber"
                  v-if="isAdmin"
                  @click="addNarasumber(null)"
                  class="btn pull-right btn-success btn-icon-left"
                >
                  <i class="bi bi-plus"></i> <span>Narasumber</span>
                </button>
              </h5>
              <input
                id="cari-narasumber"
                type="text"
                name="q"
                v-model="q_search"
                @keyup="searchEntity"
                class="form-control form-custom m-b-5"
                placeholder="Cari Narasumber"
              />

              <p
                class="m-t-10 p-1 alert alert-warning"
                align="center"
                v-if="loading_state.entity"
              >
                Loading...
              </p>
              <div v-else>
                <div class="m-t-10" v-if="entity_result.length > 0">
                  <div
                    id="narasumber"
                    class="row m-t-10 rounded"
                    :class="
                      entity.nama == selected_entity_detail.nama ? 'active' : ''
                    "
                    v-for="(entity, index) in entity_result"
                    :key="index"
                  >
                    <div
                      class="col-2 no-padding no-margin"
                      @click="entityDetail(entity)"
                    >
                      <div
                        class="bg-icon bg-primary-light rounded"
                        align="center"
                      >
                        <h3><i class="bi bi-person-vcard" /></h3>
                      </div>
                    </div>
                    <div class="col-10">
                      <div class="entity-name" @click="entityDetail(entity)">
                        <h5 class="no-margin">
                          {{ entity.nama }}
                        </h5>
                      </div>
                      <div
                        class="entity-count text-secondary fs-12"
                        @click="entityDetail(entity)"
                      >
                        Alias : {{ aliasPerson(entity) }}
                      </div>
                      <div
                        v-if="isAdmin"
                        class="entity-count text-secondary fs-12"
                      >
                        <span
                          @click="editNarasumber(entity)"
                          class="mr-2 btn-narsum font-weight-bolder text-success"
                        >
                          <i class="bi bi-pencil-square" aria-hidden="true"></i>
                          Edit
                        </span>
                        <span
                          @click="hapusNarasumber(entity._id.$oid)"
                          class="text-danger btn-narsum font-weight-bolder"
                        >
                          <i class="bi bi-trash" aria-hidden="true"></i> Hapus
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="col-md-12 col-sm-12 col-lg-12">
                  <div
                    class="alert alert-danger mt-3"
                    id="errorApiEl"
                    role="alert"
                    align="center"
                  >
                    <strong>Mohon maaf, data tidak tersedia! </strong> <br />
                    Silahkan lakukan pencarian dengan parameter lain
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-9">
            <div class="row mb-4" v-if="isSelectNarasumber">
              <div class="col-12 px-gap">
                <div id="bio-narasumber" class="bg-white rounded p-3 shade">
                  <div class="row">
                    <div class="col-md-2" v-if="!isEnableBio">
                      <div v-if="!isEnableBio">
                        <img
                          :src="
                            biodata.bio != null
                              ? biodata.bio.url_thumbnail
                                ? biodata.bio.url_thumbnail
                                : '/assets/img/profiles/default.jpg'
                              : '/assets/img/profiles/default.jpg'
                          "
                          class="border border-lg"
                          style="
                            width: 130px;
                            height: 130px;
                            object-fit: cover;
                            object-position: center;
                            border-radius: 50%;
                          "
                          @error="imageError()"
                        />
                      </div>
                    </div>
                    <div :class="!isEnableBio ? 'col-md-10' : 'col-md-12'">
                      <div class="row">
                        <div class="col-md-9">
                          <h2>
                            {{
                              selected_entity_detail
                                ? selected_entity_detail.nama
                                : ""
                            }}
                          </h2>
                        </div>
                        <div class="col-md-3">
                          <div class="pull-right mt-3">
                            <div class="form-check form-check-inline switch">
                              <input
                                type="checkbox"
                                v-model="showNarasumber"
                                id="SwitchTrenNarasumber"
                                :disabled="isLoadingNarasumber"
                                @change="
                                  changeStatusNarasumber(biodata._id.$oid)
                                "
                              />
                              <label for="SwitchTrenNarasumber">
                                {{ messageNarasumber }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <p class="mb-3" v-if="!isEnableBio">
                            {{
                              biodata.bio != null ? biodata.bio.description : ""
                            }}
                          </p>
                          <p v-if="!isEnableBio" class="text-justify">
                            {{
                              biodata.bio != null
                                ? biodata.bio.extract
                                : "Tidak ditemukan pencarian tokoh untuk " +
                                  selected_entity_detail.nama +
                                  " pada wikipedia."
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- DAFTAR QUOTES DAN GRAFIK -->
            <div class="row">
              <div class="col-8 px-gap">
                <div
                  id="statement-terkait"
                  class="bg-white rounded h-100 p-3 shade"
                >
                  <h5>
                    Statement Terkait
                    {{
                      selected_entity_detail ? selected_entity_detail.nama : ""
                    }}
                  </h5>

                  <p
                    class="m-t-10 p-1 alert alert-warning"
                    align="center"
                    v-if="loading_state.statement"
                  >
                    Loading...
                  </p>

                  <div class="post-outer" v-else-if="entity_statement != null">
                    <div class="entity-quotes-wrapper">
                      <statement-list-component
                        v-if="entity_statement != ''"
                        :quotes="entity_statement.statements"
                        :is_crud="false"
                      />
                      <div v-else class="col-md-12 col-sm-12 col-lg-12">
                        <div
                          class="alert alert-danger mt-3"
                          id="errorApiEl"
                          role="alert"
                          align="center"
                        >
                          <strong>Mohon maaf, data tidak tersedia! </strong>
                          <br />
                          Silahkan lakukan pencarian dengan parameter lain
                        </div>
                      </div>

                      <div class="clearfix"></div>
                    </div>
                    <div
                      class="d-flex align-items-center"
                      v-if="
                        entity_statement != '' &&
                        entity_statement.page_info.total_data > 10
                      "
                    >
                      <div class="">
                        Total Statement:
                        {{ entity_statement.page_info.total_data }}
                      </div>
                      <div class="ml-auto">
                        <pagination-component
                          :data="pagination"
                          :goto="true"
                          :key="pagination_statement_key"
                          class="pull-right"
                          @pageChange="
                            getEntityStatement(selected_entity_detail)
                          "
                        />
                      </div>
                    </div>
                  </div>

                  <p
                    class="m-t-10 p-1 bg-info-lighter rounded p-1"
                    align="center"
                    v-else
                  >
                    Silahkan pilih Entitas terlebih dahulu.
                  </p>
                </div>
              </div>
              <div class="col-4 px-gap">
                <div
                  id="media-share"
                  class="bg-white rounded p-3 shade"
                  style="height: 100%"
                >
                  <h5>Media Share</h5>

                  <p
                    class="m-t-10 p-1 alert alert-warning"
                    align="center"
                    v-if="loading_state.analytic"
                  >
                    Loading...
                  </p>

                  <div v-else-if="entity_analytic">
                    <pie-chart-component
                      :data="piechart_media_share"
                      :height="400"
                    />
                  </div>

                  <div
                    v-else-if="entity_analytic_check"
                    class="col-md-12 col-sm-12 col-lg-12"
                  >
                    <div
                      class="alert alert-danger mt-3"
                      id="errorApiEl"
                      role="alert"
                      align="center"
                    >
                      <strong>Mohon maaf, data tidak tersedia! </strong> <br />
                      Silahkan lakukan pencarian dengan parameter lain
                    </div>
                  </div>

                  <p
                    class="m-t-10 p-1 bg-info-lighter rounded p-1"
                    align="center"
                    v-else
                  >
                    Silahkan pilih Entitas terlebih dahulu.
                  </p>
                </div>
              </div>
            </div>
            <!-- END DAFTAR QUOTES DAN GRAFIK  -->
            <div class="row mt-4">
              <div class="col-8 px-gap">
                <div id="grafik-topik" class="bg-white rounded p-3 shade h-100">
                  <h5>
                    Grafik Topik Terkait
                    {{
                      selected_entity_detail ? selected_entity_detail.nama : ""
                    }}
                  </h5>

                  <p
                    class="m-t-10 p-1 alert alert-warning"
                    align="center"
                    v-if="loading_state.analytic"
                  >
                    Loading...
                  </p>

                  <div v-else-if="entity_analytic">
                    <bar-chart-group-stacked-component
                      :series="barchart_topik"
                      :topik="data_topik"
                      :barchart_id="'topik-terkait'"
                    />
                  </div>
                  <div
                    v-else-if="entity_analytic_check"
                    class="col-md-12 col-sm-12 col-lg-12"
                  >
                    <div
                      class="alert alert-danger mt-3"
                      id="errorApiEl"
                      role="alert"
                      align="center"
                    >
                      <strong>Mohon maaf, data tidak tersedia! </strong> <br />
                      Silahkan lakukan pencarian dengan parameter lain
                    </div>
                  </div>
                  <p
                    class="m-t-10 p-1 bg-info-lighter rounded p-1"
                    align="center"
                    v-else
                  >
                    Silahkan pilih Entitas terlebih dahulu.
                  </p>
                </div>
              </div>
              <div class="col-4 px-gap">
                <div
                  id="grafik-sentimen"
                  class="p-3 bg-white rounded shade h-100"
                  style="height: 100%"
                >
                  <h5>
                    Grafik Sentimen
                    {{
                      selected_entity_detail ? selected_entity_detail.nama : ""
                    }}
                  </h5>

                  <p
                    class="m-t-10 p-1 alert alert-warning"
                    align="center"
                    v-if="loading_state.analytic"
                  >
                    Loading...
                  </p>
                  <div v-else-if="entity_analytic">
                    <pie-chart-component :data="piechart_sentiment" />
                  </div>
                  <div
                    v-else-if="entity_analytic_check"
                    class="col-md-12 col-sm-12 col-lg-12"
                  >
                    <div
                      class="alert alert-danger mt-3"
                      id="errorApiEl"
                      role="alert"
                      align="center"
                    >
                      <strong>Mohon maaf, data tidak tersedia! </strong> <br />
                      Silahkan lakukan pencarian dengan parameter lain
                    </div>
                  </div>

                  <p
                    class="m-t-10 p-1 bg-info-lighter rounded p-1"
                    align="center"
                    v-else
                  >
                    Silahkan pilih Entitas terlebih dahulu.
                  </p>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-4 px-gap">
                <div id="grafik-emosi" class="bg-white rounded p-3 shade h-100">
                  <h5>
                    Grafik Emosi
                    {{
                      selected_entity_detail ? selected_entity_detail.nama : ""
                    }}
                  </h5>

                  <p
                    class="m-t-10 p-1 alert alert-warning"
                    align="center"
                    v-if="loading_state.analytic"
                  >
                    Loading...
                  </p>

                  <div v-else-if="entity_analytic" style="height: 300px">
                    <pie-chart-component :data="piechart_emotion" />
                  </div>
                  <div
                    v-else-if="entity_analytic_check"
                    class="col-md-12 col-sm-12 col-lg-12"
                  >
                    <div
                      class="alert alert-danger mt-3"
                      id="errorApiEl"
                      role="alert"
                      align="center"
                    >
                      <strong>Mohon maaf, data tidak tersedia! </strong> <br />
                      Silahkan lakukan pencarian dengan parameter lain
                    </div>
                  </div>

                  <p
                    class="m-t-10 p-1 bg-info-lighter rounded p-1"
                    align="center"
                    v-else
                  >
                    Silahkan pilih Entitas terlebih dahulu.
                  </p>
                </div>
              </div>
              <div class="col-8 px-gap">
                <div id="grafik-tren" class="bg-white p-3 rounded shade h-100">
                  <h5>
                    Grafik Tren Mention
                    {{
                      selected_entity_detail ? selected_entity_detail.nama : ""
                    }}
                  </h5>

                  <p
                    class="m-t-10 p-1 alert alert-warning"
                    align="center"
                    v-if="loading_state.analytic"
                  >
                    Loading...
                  </p>

                  <div v-else-if="entity_analytic" style="height: 300px">
                    <line-chart-component
                      v-if="data_tren_formed"
                      :series="data_tren_formed"
                      el="linechart-dashboard-mockup"
                      mode="dual"
                    />
                  </div>

                  <div
                    v-else-if="entity_analytic_check"
                    class="col-md-12 col-sm-12 col-lg-12"
                  >
                    <div
                      class="alert alert-danger mt-3"
                      id="errorApiEl"
                      role="alert"
                      align="center"
                    >
                      <strong>Mohon maaf, data tidak tersedia! </strong> <br />
                      Silahkan lakukan pencarian dengan parameter lain
                    </div>
                  </div>

                  <p
                    v-else
                    class="m-t-10 p-1 bg-info-lighter rounded p-1"
                    align="center"
                  >
                    Silahkan pilih Entitas terlebih dahulu.
                  </p>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12 px-gap">
                <div id="berita-terkait" class="bg-white rounded p-3 shade">
                  <h5>
                    Berita Terkait
                    {{
                      selected_entity_detail ? selected_entity_detail.nama : ""
                    }}
                  </h5>

                  <p
                    class="m-t-10 p-1 alert alert-warning"
                    align="center"
                    v-if="loading_state.post"
                  >
                    Loading...
                  </p>

                  <div class="post-outer" v-else-if="entity_post != null">
                    <div class="entity-post-wrapper">
                      <post-list-simple-component
                        v-if="entity_post.posts"
                        :posts="entity_post.posts"
                        :keyword="keyword"
                      />
                      <div v-else class="col-md-12 col-sm-12 col-lg-12">
                        <div
                          class="alert alert-danger mt-3"
                          id="errorApiEl"
                          role="alert"
                          align="center"
                        >
                          <strong>Mohon maaf, data tidak tersedia! </strong>
                          <br />
                          Silahkan lakukan pencarian dengan parameter lain
                        </div>
                      </div>

                      <div class="clearfix" />
                    </div>
                    <div
                      class="row m-t-10"
                      v-if="entity_post.page_info.total > 10"
                    >
                      <div class="col-6">
                        Total Post:
                        {{ entity_post.page_info.total }}
                      </div>
                      <div class="col-6">
                        <pagination-component
                          :data="entity_post.page_info"
                          :goto="true"
                          :key="pagination_key"
                          class="pull-right"
                          @pageChange="getEntityPost(selected_entity_detail)"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    v-else-if="entity_analytic_check"
                    class="col-md-12 col-sm-12 col-lg-12"
                  >
                    <div
                      class="alert alert-danger mt-3"
                      id="errorApiEl"
                      role="alert"
                      align="center"
                    >
                      <strong>Mohon maaf, data tidak tersedia! </strong> <br />
                      Silahkan lakukan pencarian dengan parameter lain
                    </div>
                  </div>
                  <p
                    class="m-t-10 p-1 bg-info-lighter rounded p-1"
                    align="center"
                    v-else
                  >
                    Silahkan pilih Entitas terlebih dahulu.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="row mt-4">
      <div class="col-12 px-gap">
        <div class="bg-white rounded p-3 shade">
          <p>Silahkan hubungi administrator untuk membuka fitur ini.</p>
        </div>
      </div>
    </div>
    <modal-dynamic-component
      v-if="modal"
      :key="modal_key"
      :modal="modal"
      :data="modal.data"
      :static="true"
    />
    <v-tour
      v-if="tour_steps.length > 0"
      name="myTour"
      :steps="tour_steps"
      :options="{ highlight: true }"
    ></v-tour>
  </div>
</template>

<script>
import page_header from "@/views/components/page_header.vue";
import post_list_simple from "@/views/components/post_list_simple.vue";
import statement_list from "@/views/components/quotes-extraction/statement_list.vue";
import pie_chart from "@/views/components/chart/pie_chart.vue";
import line_chart from "@/views/components/chart/line_chart.vue";
import bar_chart_group_stacked from "@/views/components/chart/bar_chart_group_stacked.vue";
import pagination_component from "@/views/components/pagination.vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_add_narasumber from "@/views/components/analytics/narasumber/modal_add_narasumber.vue";
import modal_edit_narasumber from "@/views/components/analytics/narasumber/modal_edit_narasumber.vue";
import swal from "sweetalert";

export default {
  name: "Narasumber",
  title: "Analytics Narasumber | Online Media Monitoring",
  components: {
    "page-header-component": page_header,
    "post-list-simple-component": post_list_simple,
    "statement-list-component": statement_list,
    "pie-chart-component": pie_chart,
    "line-chart-component": line_chart,
    "bar-chart-group-stacked-component": bar_chart_group_stacked,
    "pagination-component": pagination_component,
    "modal-dynamic-component": modal_dynamic,
  },
  data() {
    return {
      modal: null,
      modal_key: 0,
      tour_steps: [],
      topics: null,
      q_search: null,
      selected_entity: null,
      selected_entity_detail: {},
      isSelectNarasumber: false,
      keyword: [],
      entity_option: [],
      entity_result: [],
      entity_data: [],
      entity_type_filter: [],
      entity_type_count: [],
      loading_state: {
        entity: false,
        post: false,
        analytic: false,
        statement: false,
      },
      entity_post: null,
      entity_statement: null,
      entity_analytic: null,
      piechart_sentiment: null,
      piechart_emotion: null,
      piechart_media_share: [],
      data_tren_formed: null,
      barchart_topik: null,
      data_topik: null,
      id_project: this.$store.getters.user.id_project,
      is_narasumber: true,
      ner_type_icon: this.$ner_icon,
      bg_ner: this.$bg_color,
      pagination_key: 0,
      pagination_statement_key: 0,
      display_tipe:
        this.$store.getters.user.project.project_detail.display_tipe,
      tipe_apps: this.$store.getters.user.project.project_detail.tipe,
      entity_analytic_check: false,
      biodata: {},
      isEnableBio: false,
      showNarasumber: true,
      messageNarasumber: "Non Aktifkan Biografi",
      isLoadingNarasumber: false,
      pagination: {
        limit: 10,
        page: 1,
        total: 0,
      },
    };
  },
  methods: {
    imageError() {
      event.target.src = "/assets/img/profiles/default.jpg";
    },
    addNarasumber: function (data) {
      this.modal = {
        title: "Tambah Narasumber",
        subtitle: "Silahkan masukan nama narasumber yang akan dimonitor.",
        component: modal_add_narasumber,
        data: data != null ? data : [],
      };
      this.modal_key++;
    },
    editNarasumber: function (data) {
      let tmp_data = [];
      tmp_data.push(data);
      this.modal = {
        title: "Edit Narasumber",
        subtitle: "Silahkan edit nama narasumber yang akan dimonitor.",
        component: modal_edit_narasumber,
        data: tmp_data,
      };
      this.modal_key++;
    },
    hapusNarasumber: function (id) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus narasumber tersebut dari daftar narasumber yang dimonitor.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          let params = {
            _id: id,
          };
          self.$store.dispatch("loading", true);
          let api = process.env.VUE_APP_API_URL + "persons-delete";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                self.$store.dispatch("loading", false);
                self.getData();
                self
                  .$("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Narasumber berhasil dihapus.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
              } else {
                self.$store.dispatch("loading", false);
              }
            })
            .catch(function () {
              self
                .$("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus Narasumber.',
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
    filterChange: function () {
      this.getData();
      if ("nama" in this.selected_entity_detail) {
        this.getEntityStatement(this.selected_entity_detail);
        this.getEntityPost(this.selected_entity_detail);
        this.getEntityAnalytic(this.selected_entity_detail);
      }
    },
    getTopic: function () {
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.topics = response.data;
          } else {
            this.topics = {};
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.filterChange();
        });
    },
    getData: function () {
      let api = process.env.VUE_APP_API_URL + "persons/" + this.id_project;
      this.entity_data = [];
      this.entity_result = [];
      this.loading_state.entity = true;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.entity_data = response.data;
            this.entity_result = this.entity_data;
            this.entity_type_filter = this.entity_data;
            this.entity_type_count = response.data.entity_info;
            this.entity_option = [];
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading_state.entity = false;
        });
    },
    changeEntity: function (entity) {
      this.filterEntity(entity);
    },
    changeStatusNarasumber: function (idNarasumber) {
      this.isLoadingNarasumber = true;
      let api = "";
      if (!this.showNarasumber) {
        api = process.env.VUE_APP_API_URL + "person-bio-disable";
      } else {
        api = process.env.VUE_APP_API_URL + "person-bio-enable";
      }

      let params = {
        _id: idNarasumber,
      };

      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            if (this.showNarasumber) {
              this.showNarasumber = true;
              this.messageNarasumber = "Aktifkan Biografi";
            } else {
              this.showNarasumber = false;
              this.messageNarasumber = "Non Aktifkan Biografi";
            }
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.getBioNarasumber(idNarasumber);
          this.isLoadingNarasumber = false;
        });
    },
    filterEntity: function (entity) {
      let result = this.entity_data.filter((ent) => ent.type == entity.id);
      this.entity_type_filter = result;
      this.entity_result = result;
    },
    entityDetail: function (entity) {
      this.isSelectNarasumber = true;
      this.getBioNarasumber(entity._id.$oid);
      this.selected_entity_detail = entity;
      this.getEntityPost(entity);
      this.getEntityStatement(entity);
      this.getEntityAnalytic(entity);
    },
    getEntityPost: function (entity) {
      let api =
        process.env.VUE_APP_API_URL +
        "personSearch/" +
        this.id_project +
        "/" +
        entity.nama;
      let query = {
        from: this.$route.query.from,
        to: this.$route.query.to,
      };
      if ("page" in this.$route.query) {
        query.page = this.$route.query.page;
      }
      if ("is_validated" in this.$route.query) {
        query.is_validated = this.$route.query.is_validated;
      }
      this.loading_state.post = true;
      this.$http
        .get(api, { params: query })
        .then((response) => {
          if (response.status == 200) {
            this.entity_post = response.data;
          } else {
            this.entity_post = null;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading_state.post = false;
          this.pagination_key++;
        });
    },
    getEntityStatement: function (entity) {
      let id = entity._id["$oid"];
      let api = process.env.VUE_APP_API_URL + "person-statements/" + id;
      let query = {
        from: this.$route.query.from,
        to: this.$route.query.to,
      };
      if ("page" in this.$route.query) {
        query.page = this.$route.query.page;
      }
      this.loading_state.statement = true;
      this.$http
        .get(api, { params: query })
        .then((response) => {
          if (response.status == 200) {
            this.entity_statement = response.data;
            this.pagination.limit = response.data.page_info.items;
            this.pagination.page = response.data.page_info.page;
            this.pagination.total = response.data.page_info.total_data;
          } else {
            this.entity_statement = "";
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading_state.statement = false;
          this.pagination_statement_key++;
        });
    },
    getEntityAnalytic: function (entity) {
      let api =
        process.env.VUE_APP_API_URL +
        "personAnalytics/" +
        this.id_project +
        "/" +
        entity.nama;
      let query = {
        from: this.$route.query.from,
        to: this.$route.query.to,
      };
      if ("is_validated" in this.$route.query) {
        query.is_validated = this.$route.query.is_validated;
      }
      this.loading_state.analytic = true;
      this.$http
        .get(api, { params: query })
        .then((response) => {
          if (response.status == 200) {
            this.entity_analytic = response.data;
            this.pieChartMediaShare(this.entity_analytic.media_share);
            this.piechartFormat(this.entity_analytic.stats[0]);
            this.linechartFormat(this.entity_analytic.trend_formed);
            this.assembleDataGrafik(this.entity_analytic.bar_topik);
          } else {
            this.entity_analytic_check = true;
            this.entity_analytic = null;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading_state.analytic = false;
        });
    },
    searchEntity: function () {
      let result;
      if (this.selected_entity) {
        result = this.entity_type_filter.filter((ent) =>
          ent.nama
            .toString()
            .toLowerCase()
            .includes(this.q_search.toLowerCase())
        );
      } else {
        result = this.entity_data.filter((ent) =>
          ent.nama
            .toString()
            .toLowerCase()
            .includes(this.q_search.toLowerCase())
        );
      }
      this.entity_result = result;
    },
    pieChartMediaShare: function (dataset) {
      let color = [
        "#007bff",
        "#6c757d",
        "#28a745",
        "#17a2b8",
        "#ffc107",
        "#dc3545",
        "#343a40",
        "#28a745",
        "#ffc107",
        "#6f42c1",
      ];
      for (let i = 0; i < dataset.length; i++) {
        this.piechart_media_share[i] = {
          name: dataset[i]._id,
          y: dataset[i].count,
          color: color[i],
        };
      }
    },
    piechartFormat: function (dataset) {
      this.piechart_sentiment = [
        {
          name: "Positif",
          y: dataset.positif,
          color: this.$("body").css("--success") + "AA",
        },
        {
          name: "Netral",
          y: dataset.netral,
          color: "#0e6d87AA",
          visible: dataset.positif > 0 && dataset.negatif > 0 ? false : true,
        },
        {
          name: "Negatif",
          y: dataset.negatif,
          color: this.$("body").css("--danger") + "AA",
        },
      ];

      this.piechart_emotion = [
        {
          name: "Netral",
          y: dataset.no_emotion,
        },
        {
          name: "Senang",
          y: dataset.joy,
          color: this.$("body").css("--success") + "AA",
        },
        {
          name: "Takut",
          y: dataset.fear,
          color: this.$("body").css("--warning") + "AA",
        },
        {
          name: "Sedih",
          y: dataset.sad,
          color: this.$("body").css("--teal") + "AA",
        },
        {
          name: "Marah",
          y: dataset.anger,
          color: this.$("body").css("--danger") + "AA",
        },
      ];
    },
    linechartFormat: function (dataset) {
      this.data_tren_formed = {
        y: [
          {
            color: "#28a745",
            name: "Online News",
            data: dataset.news,
            yAxis: 1,
          },
          {
            color: "#e83e8c",
            name: "Media TV",
            data: dataset.media_tv,
          },
          {
            color: "#6c757d",
            name: "Media Cetak",
            data: dataset.media_cetak,
          },
        ],
        x: dataset.date,
        yAxis: ["Jumlah Media Cetak & TV", "Jumlah Online News"],
      };
    },
    assembleDataGrafik: function (data_grafik) {
      if (data_grafik != null) {
        let selected_topic_key = null;
        let data_topik = [];
        if ("topic" in this.$route.query) {
          for (let key in data_grafik.topics) {
            if (data_grafik.topics[key].id == this.$route.query.topic) {
              data_topik.push(data_grafik.topics[key]);
              selected_topic_key = key;
            }
          }
        }
        let data_tabel = [];
        let data_bar_chart = [];
        let chart_values = {};
        let key_value = [];
        let obj_key_value = {};

        // whitelist data
        let key_grafik = ["positif", "negatif", "netral"];
        for (let obj_key in data_grafik) {
          if (obj_key == "topics") {
            for (let arr_key in data_grafik[obj_key]) {
              if (data_grafik["total"][arr_key] > 0) {
                if (typeof data_tabel[arr_key] == "undefined") {
                  data_tabel[arr_key] = [];
                }
                data_tabel[arr_key][0] = data_grafik[obj_key][arr_key].nama;
              }
            }
          }
          if (key_grafik.includes(obj_key)) {
            key_value = [];
            for (let arr_key in data_grafik[obj_key]) {
              // check if data > 0
              if (data_grafik["total"][arr_key] > 0) {
                if (!("topic_selected" in this.$route.query)) {
                  if (data_grafik["topics"][arr_key]) {
                    data_topik[arr_key] = data_grafik["topics"][arr_key];
                  }
                }

                // ini set data buat tabel
                if (obj_key == "positif") {
                  if (typeof data_tabel[arr_key] == "undefined") {
                    data_tabel[arr_key] = [];
                  }
                  data_tabel[arr_key][1] = data_grafik[obj_key][arr_key];
                }
                if (obj_key == "netral") {
                  if (typeof data_tabel[arr_key] == "undefined") {
                    data_tabel[arr_key] = [];
                  }
                  data_tabel[arr_key][2] = data_grafik[obj_key][arr_key];
                }
                if (obj_key == "negatif") {
                  if (typeof data_tabel[arr_key] == "undefined") {
                    data_tabel[arr_key] = [];
                  }
                  data_tabel[arr_key][3] = data_grafik[obj_key][arr_key];
                }

                // set data untuk bar chart
                obj_key_value = {
                  x: arr_key,
                  y: data_grafik[obj_key][arr_key],
                };
                if (selected_topic_key != null) {
                  if (selected_topic_key == arr_key) {
                    key_value.push(obj_key_value);
                  }
                } else {
                  key_value.push(obj_key_value);
                }
              }
            }
            chart_values = {
              key: this.capitalizeWords(obj_key),
              values: key_value,
            };
            if (obj_key == "positif") data_bar_chart[0] = chart_values;
            if (obj_key == "netral") data_bar_chart[1] = chart_values;
            if (obj_key == "negatif") data_bar_chart[2] = chart_values;
          }
        }
        this.barchart_topik = data_bar_chart;
        this.data_topik = data_topik;
        return {
          table_data: data_tabel,
          grafik_data: data_bar_chart,
          data_topik: data_topik,
        };
      }
    },
    capitalizeWords: function (str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    toNarasumberPage: function () {
      let index = 0;
      let subtab = 0;
      if (this.tipe_apps == 2) {
        index = 2;
      } else {
        if (this.display_tipe == 3) {
          index = 0;
          subtab = 5;
        }
        if (this.display_tipe == 2) {
          index = 0;
          subtab = 1;
        }
        if (this.display_tipe == 1) {
          index = 0;
          subtab = 4;
        }
      }
      let route_query = {
        "keyword-active-tab": index,
      };
      if (subtab > 0) {
        route_query["keyword-active-sub-tab"] = subtab;
      }
      this.$router.push({
        path: "settings",
        query: route_query,
      });
    },
    getBioNarasumber: function (idNarusmber) {
      let api = process.env.VUE_APP_API_URL + "person/" + idNarusmber;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.biodata = response.data;
            this.keyword[0] = this.biodata.nama;
            for (let i = 1; i <= this.biodata.alias.length; i++) {
              this.keyword[i] = this.biodata.alias[i - 1];
            }
            if ("disable_bio" in this.biodata) {
              if (this.biodata.disable_bio) {
                this.isEnableBio = true;
                this.showNarasumber = false;
                this.messageNarasumber = "Aktifkan Biografi";
              } else {
                this.isEnableBio = false;
                this.showNarasumber = true;
                this.messageNarasumber = "Non Aktifkan Biografi";
              }
            }
          } else {
            this.biodata = null;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    aliasPerson: function (data) {
      if ("alias" in data) {
        return data.alias.toString();
      } else {
        return "-";
      }
    },
  },
  watch: {
    selected_entity() {
      if (!this.selected_entity) {
        this.entity_result = this.entity_data;
      }
    },
  },
  computed: {
    isAdmin: function () {
      let user_role = this.$store.getters.user.role;
      if (user_role == 2 || user_role == 3) {
        return true;
      }

      return false;
    },
  },
  created: function () {
    this.getTopic();
  },
  mounted() {
    let v_step = [];
    v_step[0] = {
      target: "#page-header-validasi",
      header: {
        title: "Filter Validasi",
      },
      content: `Digunakan untuk memfilter data berdasarkan status validasi`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#page-header-select",
      header: {
        title: "Filter Topik",
      },
      content: `Digunakan untuk memfilter data berdasarkan topik`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#reportrange",
      header: {
        title: "Filter Periode",
      },
      content: `Digunakan untuk memfilter data berdasarkan periode waktu`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#tambah-narasumber",
      header: {
        title: "Tambah Narasumber",
      },
      content: `Klik untuk menambahkan data narasumber baru.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#cari-narasumber",
      header: {
        title: "Cari Narasumber",
      },
      content: `Masukkan kata kunci berupa nama narasumber untuk mencari narasumber yang diinginkan.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[5] = {
      target: "#narasumber",
      header: {
        title: "Daftar Narasumber",
      },
      content: `Menampilkan data narasumber yang tersedia. Anda bisa klik salahsatu narasumber untuk melihat detail dari narasumber dipilih`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[6] = {
      target: "#statement-terkait",
      header: {
        title: "Statement Terkait",
      },
      content: `Menampilkan daftar statement dari narasumber yang dipilih. Klik lihat berita untuk melihat detail berita dari statement terkait.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[7] = {
      target: "#media-share",
      header: {
        title: "Media Share",
      },
      content: `Menampilkan diagram dari media terkait narasumber yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[8] = {
      target: "#grafik-topik",
      header: {
        title: "Grafik Topik",
      },
      content: `Menampilkan grafik topik dengan jumlah per sentimen terkait narasumber yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[9] = {
      target: "#grafik-sentimen",
      header: {
        title: "Grafik Sentimen",
      },
      content: `Menampilkan diagram persentase jumlah sentimen terkait narasumber yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[10] = {
      target: "#grafik-emosi",
      header: {
        title: "Grafik Emotion",
      },
      content: `Menampilkan diagram persentase jumlah emotion terkait narasumber yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[11] = {
      target: "#grafik-tren",
      header: {
        title: "Grafik Tren Mention",
      },
      content: `Menampilkan grafik tren mention pada media konvensional terkait narasumber yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[12] = {
      target: "#berita-terkait",
      header: {
        title: "Berita Terkait",
      },
      content: `Menampilkan daftar berita terkait narasumber yang dipilih. Klik kunjungi untuk melihat berita yang dipilih`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };

    this.tour_steps = v_step;
  },
};
</script>

<style scoped>
.entity-result {
  height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
}
.entity-result .row {
  padding: 10px;
}
.entity-result .row:hover {
  background: #d3eeff !important;
  cursor: pointer;
}
.bg-icon {
  padding: 2px 5px;
}
.bg-icon i {
  color: #ffffff;
}
.active {
  background: #d3eeff !important;
}
.btn-narsum:hover {
  opacity: 0.5;
}
</style>